import { motion } from 'framer-motion';
import { Award } from 'lucide-react';

/* ═══════════════════════════════════════════
   EDITABLE: Achievements data
   - Edit title, awardedBy for each achievement
   - Add or remove achievements as needed
═══════════════════════════════════════════ */
const achievements = [
  { title: 'Top Financial Advisor 2018', awardedBy: 'Mumbai Financial Association' },
  { title: 'Best Client Service Award 2020', awardedBy: 'NJ India Invest' },
  { title: 'MDRT Qualifier 2019-2024', awardedBy: 'MDRT (USA)' },
  { title: 'Top 5 Mutual Fund Distributor', awardedBy: 'Mumbai Region' },
  { title: 'Highest Net Equity Sales 2022', awardedBy: 'Partner Network' },
  { title: 'Customer Excellence Award 2023', awardedBy: 'Industry Recognition' },
];

export const AchievementsSection = () => {
  return (
    <section id="achievements" data-testid="achievements-section" className="py-20 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-14"
        >
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#D4AF37] mb-4">
            Our Achievements
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-bold text-[#0A192F]">
            Testament to Our Hard Work & Dedication
          </h2>
        </motion.div>

        {/* Achievements Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {achievements.map((achievement, index) => (
            <motion.div
              key={index}
              data-testid={`achievement-card-${index}`}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              className="bg-white rounded-xl p-6 flex items-start gap-4 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-gray-100"
            >
              <div className="w-12 h-12 bg-[#D4AF37]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Award size={22} className="text-[#D4AF37]" />
              </div>
              <div>
                <h4 className="font-['Playfair_Display'] text-base font-bold text-[#0A192F] mb-1">
                  {achievement.title}
                </h4>
                <p className="text-xs text-[#49566B] font-['Outfit']">by {achievement.awardedBy}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
